<template>
  <div style="display: flex;justify-content: space-evenly;">
    <img v-if="imageDialog.url && index == 0" @click="openImageDialog" v-for="(item, index) in imageUrls" :key="index" :src="item" style="width: 50px;height: 50px;cursor: pointer;" >
    <el-dialog :visible.sync="imageDialog.visible" :close-on-click-modal="false" width="40%"
               title="查看图片">
      <div style="display: flex;justify-content: center;align-items: center;height: 500px;">
        <img :src="imageUrls[index]"/>
      </div>
      <div class="dialog-btn">
        <el-button type="primary" @click="pre" v-if="index != 0">上一张</el-button>
        <el-button type="primary" @click="next" v-if="index != length - 1">下一张</el-button>
        <el-button @click="download">下载</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>

export default {
  props: {
    urls: {
      type: String,
      default: ''
    }
  },
  watch: {
    urls(val) {
      this.imageDialog.url = val
      this.imageUrls = val.split(',')
      this.length = this.imageUrls.length
    }
  },
  data() {
    return {
      imageDialog: {
        visible: false,
        url: '',
      },
      index: 0,
      imageUrls: '',
      length: 0
    }
  },
  mounted() {
    this.imageDialog.url = this.urls
    this.imageUrls = this.urls.split(',')
    this.length = this.imageUrls.length
  },
  methods: {
    pre() {
      this.index -= 1
    },
    next() {
      this.index += 1
    },
    openImageDialog() {
      this.index = 0
      this.imageDialog.visible = true
    },
    download() {
      window.open(this.imageUrls[this.index]);
    }
  }
}
</script>

<style scoped>

img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
</style>



// WEBPACK FOOTER //
// src/components/ImageDialog.vue